const S = require('string');

function formatOrdinal(number) {
    let edition = S(number).isNumeric() ? parseInt(number) : 0;
    let ends = ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"];
    if (edition % 100 >= 11 && edition % 100 <= 13) {
        return edition + "th";
    } else {
        return edition + ends[edition % 10];
    }
}

function getCleanSeoStr(string) {
    let bookDisplayTitle = S(string).trim().s;
    if (!bookDisplayTitle) {
        return '';
    }
    bookDisplayTitle = S(bookDisplayTitle).decodeHTMLEntities().s;
    bookDisplayTitle = S(bookDisplayTitle).collapseWhitespace().s;
    bookDisplayTitle = S(bookDisplayTitle).stripTags().s;
    bookDisplayTitle = S(bookDisplayTitle).titleCase().s
    return bookDisplayTitle;
}

function cleanProblem(problemHtml) {
    let problemHtmlText = '';
    problemHtmlText = S(problemHtml).decodeHTMLEntities().s;
    problemHtmlText = (S(problemHtmlText).stripTags().s).trim();
    problemHtmlText = (problemHtmlText).replace(/(?!<\u00a0)\u00a0(?!\u00a0)/g, ' ').trim();
    problemHtmlText = S(problemHtmlText).escapeHTML().s;
    problemHtmlText = problemHtmlText.replace(/&amp;/g, '&');
    problemHtmlText = (problemHtmlText && problemHtmlText.length > 55) ? problemHtmlText.substring(0, 55) + '...' : problemHtmlText;
    return problemHtmlText;
};

export function generateTitle(coverName, editionNumber, chapterName, problemName, problemHtml, total_steps) {
    let pageTitle = "";
    let cheggString = " | Chegg.com";
    let solvedString = "Solved: ";
    let hasSolution = !!total_steps;
    if (problemHtml && problemHtml.length) {
        let problemText = cleanProblem(problemHtml);
        pageTitle = problemText + cheggString;
    } else {
        let editionText = formatOrdinal(editionNumber) + ' Edition';
        let bookDisplayTitle = getCleanSeoStr(coverName + ' ' + editionText);
        let chapterTitle = "Chapter " + chapterName;
        let problemTitle = " Problem " + problemName.toUpperCase();;
        let solutionString = " Solution | ";
        pageTitle = chapterTitle + problemTitle + solutionString + bookDisplayTitle + cheggString;
    }
    if (hasSolution) {
        pageTitle = solvedString + pageTitle;
    }
    return pageTitle;
}


// WEBPACK FOOTER //
// ./src/helpers/title.js